const pageType =  {
    Type_Workspace : "workspace",
    Type_Organization : "organization"
};

export default pageType;